import { v4 as uuid } from 'uuid';
class FacebookLoginPopupService {
    static $inject = ['BLIP_DOMAIN_URL', 'FACEBOOK_DEFAULT_URL', '$window'];
    constructor(BLIP_DOMAIN_URL, FACEBOOK_DEFAULT_URL, $window) {
        'ngInject';
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
        this.FACEBOOK_DEFAULT_URL = FACEBOOK_DEFAULT_URL;
        this.$window = $window;
    }
    openFacebookLoginPopup(appId, graphApiVersion, scope, extras, configId) {
        const state = uuid();
        const redirectUri = `${this.BLIP_DOMAIN_URL.replace(/\/\s*$/, '')}/facebookCallback`;
        const baseUrl = `${this.FACEBOOK_DEFAULT_URL}${graphApiVersion}`;
        // do not indent this url, a whitespace will generate a '%20' on URL and fail the popup
        let url = `${baseUrl}/dialog/oauth?client_id=${appId}&redirect_uri=${redirectUri}&state=${state}&`;
        if (configId) {
            url += `response_type=code&config_id=${configId}`;
        }
        else {
            url += `response_type=token&scope=${scope}`;
        }
        if (extras) {
            url = url + `&extras=${extras}`;
        }
        const tab = this.$window.open(url, 'FacebookAuth', 'height=700,width=600,location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes');
        return [state, tab];
    }
}
FacebookLoginPopupService.$inject = ['BLIP_DOMAIN_URL', 'FACEBOOK_DEFAULT_URL', '$window'];
export default FacebookLoginPopupService;
